import { InputGroup } from '@/components/InputGroup'
import { FormRow } from '@/containers/forms/FormRow'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { useSelectedQuote } from '@/context/SelectedQuoteContext'
import { useSelections } from '@/hooks'
import { FormControl, FormLabel, Select } from '@chakra-ui/react'
import { Insurer, Selection, SelectionType } from 'BrokerTsLib/src/enums'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import type { Step4FormValues } from '../Step4'

export const PreviousContractNumberForm = () => {
  const { register, formState: { errors }, getValues, watch } = useFormContext<Step4FormValues>()

  const pcn = getValues('meetingRecord.previousContractNumber')
  const overpaymentTypeId = watch('meetingRecord.contractReplacementOverpaymentTypeId')
  const { offer } = useSelectedQuote()
  const { data: dataZv } = useSelections(SelectionType.ZpusobVraceniPreplatkuNahrazovaneSmlouvy)
  const { isContracted } = useInsuranceParams()

  const showZpusobVraceniPreplatku = offer?.insurerId == Insurer.CPP || offer?.insurerId == Insurer.Kooperativa

  if (!pcn) {
    return (<></>)
  }

  return (
    <FormRow>
      <FormControl>
        <FormLabel>Náhrada smlouvy č.</FormLabel>
        <InputGroup
          {...register('meetingRecord.previousContractNumber')}
          isDisabled
        />
      </FormControl>

      {showZpusobVraceniPreplatku &&
                <>
                  <FormControl isInvalid={!!errors.meetingRecord?.contractReplacementOverpaymentTypeId?.message}>
                    <FormLabel>Způsob vrácení přeplatku z nahrazované smlouvy</FormLabel>

                    {dataZv &&
                            <Select
                              {...register('meetingRecord.contractReplacementOverpaymentTypeId')}
                              isDisabled={isContracted}
                            >
                              <option value='' >Vyberte</option>
                              {dataZv?.data.filter(item => offer?.insurerId != Insurer.Kooperativa || item.id != Selection.OverpaymentTypeNewInsurance).map((item) => (
                                <option value={item.id.toString()} key={item.id}>
                                  {item.description}
                                </option>
                              ))}
                            </Select>
                    }
                  </FormControl>


                  {overpaymentTypeId && overpaymentTypeId == Selection.OverpaymentTypeBankTransfer &&
                        <FormControl isInvalid={!!errors.meetingRecord?.contractReplacementOverpaymentAccount?.message}>
                          <FormLabel>Číslo účtu</FormLabel>
                          <InputGroup
                            isDisabled={isContracted}
                            {...register('meetingRecord.contractReplacementOverpaymentAccount')}
                          />
                        </FormControl>
                  }
                </>
      }
    </FormRow>
  )
}